import { parseDataForEditor } from 'scripts/helpers/util.js'

var fetching = []

const state = {
  all: []
}

const mutations = {
  ADD_COLLECTION (state, collection) {
    let index = state.all.find(c => c.id === c.id)

    fetching.splice(fetching.indexOf(collection.handle), 1)
    if (index > -1) {
      state.all.splice(index, 1, collection)
    } else {
      state.all.push(collection)
    }
  }
}

const actions = {
  addCollection ({ commit }, {handle, page}) {
    if (fetching.indexOf(handle) < 0) {
      fetching.push(handle)
      fetch(`/collections/${handle}?page=${page}&view=json`)
        .then((blob) => blob.json())
        .then(response => {
          commit('ADD_COLLECTION', parseDataForEditor(response))
        })
    }
  }
}

export default { namespaced: true, state, mutations, actions }
